import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";

export const updatePartnerSettings = async ({ data, token }) => {
  const response = await httpClient(
    "POST",
    ApiEndpoint + "updatePartnersettings",
    data,
    token,
  );

  return response.data;
};
